export default __webpack_public_path__ + "74f6da4a1a3bef1e74e1e287bc7e67f5.svg";